"use client";

import Link from "next/link";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";
import { SheetClose } from "@/components/ui/sheet";
import { HTMLAttributeAnchorTarget } from "react";

interface SidebarLinksProps {
  name: string;
  href: string;
  target: HTMLAttributeAnchorTarget;
}

const sidebarLinks: SidebarLinksProps[] = [
  {
    name: "Home",
    href: "/",
    target: "",
  },
  {
    name: "Bridge",
    href: "/bridge",
    target: "",
  },
  {
    name: "Swap",
    href: "/swap",
    target: "",
  },
  {
    name: "Stake",
    href: "/staking",
    target: "",
  },
  {
    name: "Origin",
    href: "https://origin.campnetwork.xyz",
    target: "_blank",
  },
  // {
  //   name: "Community",
  //   href: "/community",
  //   target: "",
  // },
  {
    name: "Explore",
    href: "/explore",
    target: "",
  },
];

export default function SideBar({ isMobile = false }: { isMobile?: boolean }) {
  const pathname = usePathname();

  const LinkComponent = ({
    link,
    isActive,
  }: {
    link: SidebarLinksProps;
    isActive: boolean;
  }) => {
    const linkContent = (
      <>
        {isActive && (
          <>
            <span className="absolute top-2 left-2 aspect-square size-1 bg-[#FF6D01]" />
            <span className="absolute top-2 right-2 aspect-square size-1 bg-[#FF6D01]" />
            <span className="absolute bottom-2 left-2 aspect-square size-1 bg-[#FF6D01]" />
            <span className="absolute right-2 bottom-2 aspect-square size-1 bg-[#FF6D01]" />
          </>
        )}
        {link.name}
      </>
    );

    const linkClassName = cn(
      "relative flex w-full border border-transparent p-4 px-5 font-sans text-sm leading-4 font-medium -tracking-[0.43px] text-[#1A1A1A] uppercase transition-all duration-300",
      isActive && "border-[#FF6D01] bg-[#FFF0E5]",
      !isActive && "hover:bg-[#F4F4F4]",
    );

    if (isMobile) {
      return (
        <SheetClose asChild>
          <Link
            key={link.name}
            href={link.href}
            target={link.target}
            className={linkClassName}>
            {linkContent}
          </Link>
        </SheetClose>
      );
    }

    return (
      <Link
        key={link.name}
        href={link.href}
        target={link.target}
        className={linkClassName}>
        {linkContent}
      </Link>
    );
  };

  return (
    <div className="flex h-full w-full flex-col items-start gap-3.5 px-6 py-5">
      {sidebarLinks.map((link) => {
        const isActive = pathname === link.href && link.target !== "_blank";
        return (
          <LinkComponent key={link.name} link={link} isActive={isActive} />
        );
      })}
    </div>
  );
}
